import { PipeableArray } from '../base/pipeable/pipeable_array.js';
import { Review } from './review.js';
import { ReviewsBaseMixin } from './reviews_base_mixin.js';
import { ReviewsPipeables } from './reviews_pipeables.js';

class Reviews extends ReviewsBaseMixin(PipeableArray) {
  setReviews(reviews) {
    this.set(reviews);
  }

  static Pipeables = ReviewsPipeables;
  static Review = Review;

  #ratings;
}

export { Reviews };
